import { render, staticRenderFns } from "./resetEMail.vue?vue&type=template&id=41b8a85d&scoped=true&"
import script from "./resetEMail.vue?vue&type=script&lang=js&"
export * from "./resetEMail.vue?vue&type=script&lang=js&"
import style0 from "./resetEMail.vue?vue&type=style&index=0&id=41b8a85d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b8a85d",
  null
  
)

export default component.exports